import i18n from '@/i18n';


export const buildRequiredValidator = () => {
    return (v) => !!v || i18n.t('validation.required');
};

export const buildRequiredIfValidator = (condition) => {
    return (v) => !condition() || !!v || i18n.t('validation.required');
};

export const buildMaxLengthValidator = (max) => {
    return (v) => !v || v.length <= max || i18n.t('validation.maxLength', null, { max: max, used: v.length });
};

export const buildEmailValidator = () => {
    return (v) => !v || /.+@.+\..+/.test(v) || i18n.t('validation.emailInvalid');
};

export const buildMaxFileSizeValidator = (maxInMB) => {
    return (v) => !v || v.size <= maxInMB*1024*1024 || i18n.t('validation.maxFilesize', null, { max: maxInMB, size: (v.size/(1024*1024)).toFixed(1) });
};


